import * as CANNON from 'cannon-es'
import { Euler } from 'three'

export default class WorldTrack {
  constructor(world, material) {
    this.world = world

    const groundShape = new CANNON.Plane()
    this.body = new CANNON.Body({ mass: 0, shape: groundShape, material })
    const axis = new CANNON.Vec3(1, 0, 0), angle = -Math.PI/2
    this.body.quaternion.setFromAxisAngle(axis, angle)
    this.body.position.y = -37

    this.bindToMesh = this.bindToMesh.bind(this)

    this.world.bodies.push(this.body) 
  }

  bindToMesh({mesh}) {
    this.mesh = mesh
    this.body.position.set(mesh.position.x, mesh.position.y, mesh.position.z)
  }

  update() {
    this.mesh.position.set(this.body.position.x, this.body.position.y, this.body.position.z)
    const rotation = new CANNON.Vec3(0,0,0)
    this.body.quaternion.toEuler(rotation, 'YZX')
    rotation.x += Math.PI / 2
    this.mesh.setRotationFromEuler(new Euler(...Object.values(rotation), 'YZX'))
  }
  
}